import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import ReactMarkdown from 'react-markdown';
import classNames from 'classnames';

import useQuestion from '../useQuestion';
import useStyles from './styles';
import RenderIf from '../../../../renderIf';
import { ShipyardContext } from '../../../../Context';
import InvalidReason from '../invalidReason';

const MultiLinePlainText = (props) => {
    const { question, disabled, appInstanceId, shouldShowErrors, answerUpdated } = props;

    //#TODO TechDebt - This is only necessary because the Parent Application view was designed to manipulate these questions directly rather than properly calling setters. This needs to be refactored.
    const handleQuestion = (newQuestion) => {
        question.answerText = newQuestion.answerText;
        question.isValid = newQuestion.isValid;
        question.invalidReason = newQuestion.invalidReason;
        answerUpdated();
    };

    const { userSettings } = React.useContext(ShipyardContext);

    const { id, answerText, text, isSaving, isValid, showErrors, invalidReason, minResponseRequired, update, save } = useQuestion(
        question,
        appInstanceId,
        shouldShowErrors,
        handleQuestion
    );

    const classes = useStyles();

    return (
        <div
            style={{
                marginBottom: '1rem',
            }}
        >
            <label
                data-error={showErrors && !isValid}
                className={classNames({
                    [classes.label]: true,
                    [classes.required]: minResponseRequired > 0,
                })}
                htmlFor={`quest-${id}`}
                aria-labelledby={`quest-${id}`}
            >
                <ReactMarkdown
                    children={text['en-US']}
                    linkTarget="_blank"
                />

                <RenderIf isTrue={isSaving}>
                    <FontAwesomeIcon
                        className={classes.spinner}
                        icon={faSpinner}
                    />
                </RenderIf>
            </label>
            <textarea
                id={`quest-${id}`}
                rows={7}
                data-error={showErrors && !isValid}
                disabled={isSaving || disabled}
                value={answerText}
                className={classes.textarea}
                onChange={(event) => update(event.target.value)}
                onBlur={() => save()}
            />

            <RenderIf isTrue={showErrors && !isValid}>
                <InvalidReason
                    className={classes.invalidReason}
                    text={invalidReason}
                    lang={userSettings.LanguagePreference}
                />
            </RenderIf>
        </div>
    );
};

export default MultiLinePlainText;
